import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { FacilityInventoryCountDetailEditForm } from "application/facility-inventory/forms";
import { FacilityInventoryCountDetailService } from "application/facility-inventory/services";
import { ProductService } from "application/product/services";
import { action, observable } from "mobx";
import _ from "lodash";
import { applicationContext } from "core/utils";
import { LookupService } from "common/services";

@applicationContext
class FacilityInventoryCountEditViewStore extends BaseEditViewStore {
    form = new FacilityInventoryCountDetailEditForm({
        onSuccess: async (form) => {
            await this.onSubmit(form.values());
        },
    });
    params = {
        id: this.rootStore.routerStore.routerState.params.id,
        facilityInventoryCountHeaderId:
            this.rootStore.routerStore.routerState.params
                .facilityInventoryCountHeaderId,
    };
    @observable accessor firstFetch = true;
    @observable accessor duplicateItems = null;
    @observable accessor eachProduct = 0;
    constructor(rootStore, componentProps) {
        const service = new FacilityInventoryCountDetailService(
            rootStore.application.baasic.apiClient
        );
        const productService = new ProductService(
            rootStore.application.baasic.apiClient
        );
        const id = rootStore.routerStore.routerState.params.id;
        const facilityInventoryCountHeaderId =
            rootStore.routerStore.routerState.params
                .facilityInventoryCountHeaderId;

        super(rootStore, {
            name: "facility-inventory-detail",
            id: id,
            Form: FacilityInventoryCountDetailEditForm,
            authorization: "portalSection.update",
            actions: {
                get: async (id, opts) => {
                    const response = await service.get(
                        id,
                        _.extend(opts, {
                            embed: "Product",
                        })
                    );

                    this.caseProduct = null;
                    var itemId = response.data.product.itemId
                        .toLowerCase()
                        .replace("-n", "-cs-n")
                        .replace("-b", "-cs-b");
                    if (itemId.indexOf("-cs") > -1) {
                        const response = (
                            await productService.find({
                                itemIds: itemId,
                                isActive: true,
                            })
                        ).data.item;
                        this.caseProduct =
                            response.length > 0 ? response[0] : null;
                    }

                    let data = _.extend(
                        response.data,
                        this.caseProduct &&
                            this.caseProduct.qtyPerCase &&
                            this.caseProduct.qtyPerCase > 0
                            ? {
                                  caseQty:
                                      response.data.quantity > 0
                                          ? Math.floor(
                                                response.data.quantity /
                                                    this.caseProduct.qtyPerCase
                                            )
                                          : 0,
                                  eachQty:
                                      response.data.quantity > 0
                                          ? response.data.quantity %
                                            this.caseProduct.qtyPerCase
                                          : 0,
                              }
                            : { caseQty: 0, eachQty: response.data.quantity }
                    );

                    this.form.update(data);

                    return data;
                },
                update: async (resource) => {
                    const response = await service.update(
                        _.extend(resource, {
                            facilityInventoryCountHeaderId:
                                facilityInventoryCountHeaderId,
                        })
                    );
                    return response.data;
                },
                create: async (resource) => {
                    const response = await service.create(
                        _.extend(resource, {
                            facilityInventoryCountHeaderId:
                                facilityInventoryCountHeaderId,
                        })
                    );
                    return response.data;
                },
            },
            errorActions: {
                onCreateError: ({ error }) => {
                    rootStore.notificationStore.error(
                        "FACILITY_INVENTORY_DETAIL.CREATE.ERROR",
                        error
                    );
                },
                onUpdateError: ({ error }) => {
                    rootStore.notificationStore.error(
                        "FACILITY_INVENTORY_DETAIL.EDIT.ERROR",
                        error
                    );
                },
            },
            FormClass: FacilityInventoryCountDetailEditForm,
        });

        if (!this.id) {
            this.onCreate = componentProps.onCreate;
        }
        this.isCreate = componentProps.isCreate;

        this.service = new FacilityInventoryCountDetailService(
            rootStore.application.baasic.apiClient
        );

        this.lookupService = new LookupService(
            rootStore.application.baasic.apiClient
        );

        // this.productRef = React.createRef();
        // this.quantityRef = React.createRef();
        this.productStore = new BaasicDropdownStore(
            {
                filterable: true,
            },
            {
                fetchFunc: async (term) => {
                    if (!this.unitOfMeasure || !this.subCategories) {
                        await this.getLookups();
                    }

                    const response = await productService.find({
                        sort: "itemId|asc",
                        searchQuery: term,
                        rpp: 100,
                        isActive: true,
                        itemCategoryId: this.itemCategory,
                        procedureCodesToExclude: "B9002,E0776",
                        unitOfMeasureIdToExclude: this.unitOfMeasure.find(
                            (uom) => uom.abrv == "CA"
                        ).id,
                        subCategoryIdToExclude: this.subCategories.find(
                            (s) => s.abrv === "G-Tube"
                        ).id,
                    });

                    var items = response.data.item.filter(
                        (p) => !p.itemId.toLowerCase().includes("-cs")
                    );

                    return _.map(items, (item) => {
                        return {
                            id: item.id,
                            name: item.itemId + " " + item.description,
                            itemId: item.itemId,
                        };
                    });
                },
                onChange: async () => {
                    this.form.$("quantity").value = null;
                    this.form.$("eachQty").value = null;
                    this.form.$("caseQty").value = null;
                    this.caseProduct = null;
                    var itemId = this.productStore.value.itemId
                        .toLowerCase()
                        .replace("-n", "-cs-n")
                        .replace("-b", "-cs-b");
                    if (itemId.indexOf("-cs") > -1) {
                        const response = (
                            await productService.find({
                                itemIds: itemId,
                                isActive: true,
                            })
                        ).data.item;
                        this.caseProduct =
                            response.length > 0 ? response[0] : null;
                    }
                },
                // onClose: () =>
                // {
                // 	// if(this.quantityRef.current!==null)
                // 	// {
                // 	// 	this.quantityRef.current.focus();
                // 	// }
                // }
            }
        );
    }

    @action
    setItem(item) {
        this.item = item;
        this.itemInitialized = true;
        this.productStore.setValue(item.product);
        // if(this.productRef.current!==null)
        // {
        // 	setTimeout(() =>
        // 		this.productRef.current.focus(), 1000
        // 	);
        // }
    }

    @action.bound
    async getLookups() {
        const result = await this.lookupService.getLookups("UnitOfMeasure");
        const resultSubCategory = await this.lookupService.getLookups(
            "SubCategory"
        );
        this.unitOfMeasure = result.unitOfMeasure;
        this.subCategories = resultSubCategory.subCategory;
    }

    @action.bound
    async getExisting(facilityInventoryCountHeaderId, productId) {
        const response = await this.service.getExisting(
            facilityInventoryCountHeaderId,
            productId
        );
        return response;
    }

    @action.bound
    async getEachProduct(productId) {
        var productService = new ProductService(
            this.rootStore.application.baasic.apiClient
        );
        const productResponse = await productService.get(productId);
        if (productResponse.data.itemId.toLowerCase().includes("-cs")) {
            const response = await productService.getEachProduct(productId);
            return response;
        }
        return 0;
    }

    @action.bound
    async updateQuantity(value, propertyName) {
        if (value == null || value == undefined || value === "") value = 0;

        if (
            !this.caseProduct ||
            !this.caseProduct.qtyPerCase ||
            this.caseProduct.qtyPerCase === 0
        ) {
            if (propertyName === "caseQty") {
                this.form.$("caseQty").value = 0;
                this.rootStore.notificationStore.error(
                    "Case Qty cannot be entered for a product that doesn't have its case version."
                );
            } else {
                this.form.$("eachQty").value = value;
            }
        } else {
            if (
                propertyName === "eachQty" &&
                value >= this.caseProduct.qtyPerCase
            ) {
                this.form.$("caseQty").value += Math.floor(
                    value / this.caseProduct.qtyPerCase
                );
                value = value % this.caseProduct.qtyPerCase;
            }

            this.form.$(propertyName).value = value;
        }
    }

    @action.bound
    async updateResource(resource, facilityInventoryCountHeaderId) {
        this.form.setFieldsDisabled(true);
        try {
            await this.actions.update({
                id: this.id,
                ...resource,
                facilityInventoryCountHeaderId: facilityInventoryCountHeaderId,
            });
            this.rootStore.routerStore.goBack();
            this.form.setFieldsDisabled(false);
            await setTimeout(() =>
                this.rootStore.notificationStore.success(
                    "FACILITY_INVENTORY.EDIT.COUNT_DATE_SUCCESS"
                )
            );
        } catch (error) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                error && error.data ? error.data : `An error ocurred`
            );
        }
    }

    @action.bound
    async saveResource(resource, facilityInventoryCountHeaderId) {
        await this.service.create(
            _.extend(resource, {
                facilityInventoryCountHeaderId: facilityInventoryCountHeaderId,
            })
        );
        await this.onCreate();
        this.form.reset();
        resource.productId = null;
        resource.quantity = null;
        resource.eachQty = null;
        resource.caseQty = null;
        this.form.$("productId").clear();

        this.form.$("quantity").value = null;
        this.form.$("eachQty").value = null;
        this.form.$("caseQty").value = null;

        this.form.update(resource, facilityInventoryCountHeaderId);
        this.duplicateItems = null;
        this.eachProduct = 0;
        this.caseProduct = null;
        this.form.setFieldsDisabled(false);
        this.productStore.value = null;
        // setTimeout(() =>
        // 	this.productRef.current.focus(), 1000
        // );
        await setTimeout(() =>
            this.rootStore.notificationStore.success(
                "FACILITY_INVENTORY.ADD.SUCCESS",
                10
            )
        );
    }

    @action.bound
    async onSubmit(resource) {
        var id = this.rootStore.routerStore.routerState.params.id;

        resource.quantity =
            this.caseProduct && this.caseProduct.qtyPerCase
                ? resource.caseQty * this.caseProduct.qtyPerCase +
                  resource.eachQty
                : resource.eachQty;
        if (!resource.quantity) resource.quantity = 0;

        if (id !== undefined) {
            return this.updateResource(resource);
        } else {
            return this.createResource(resource);
        }
    }

    @action.bound
    async createResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            var facilityInventoryCountHeaderId =
                this.rootStore.routerStore.routerState.params
                    .facilityInventoryCountHeaderId;
            this.eachProduct = await this.getEachProduct(resource.productId);
            this.duplicateItems = await this.getExisting(
                facilityInventoryCountHeaderId,
                resource.productId
            );
            if (this.duplicateItems == 0 && this.eachProduct !== null) {
                await this.saveResource(
                    resource,
                    facilityInventoryCountHeaderId
                );
            } else {
                // setTimeout(() =>
                // 	this.productRef.current.focus(), 1000
                // );
                this.form.setFieldsDisabled(false);
                return;
            }
        } catch (error) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                error && error.data ? error.data : `An error ocurred`
            );
        }
    }
}

export default FacilityInventoryCountEditViewStore;
